import { render, staticRenderFns } from "./shortcut_options_modal.vue?vue&type=template&id=6c840393"
import script from "./shortcut_options_modal.vue?vue&type=script&lang=js"
export * from "./shortcut_options_modal.vue?vue&type=script&lang=js"
import style0 from "./shortcut_options_modal.vue?vue&type=style&index=0&id=6c840393&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports